import React, { Component } from 'react';
import RegionComponent from '../components/regionComponent';
import {getAllRegionSettings, addRegionData,
            deleteRegionData, editRegionData} from '../action/regionAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

export class RegionContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllRegionSettings();
    }
    getRegion = () =>{
        this.props.actions.getAllRegionSettings(
            this.props.dispatch
        )
    }
    updateRegion = (formData) =>{
        this.props.actions.editRegionData(
            formData,
            this.props.dispatch
        )
    }
   getRegionData = () => {
          this.props.actions.getAllRegionSettings(this.props.dispatch);
       } 
    addRegionSetting = (formData) =>{
        this.props.actions.addRegionData(
            formData,
            this.props.dispatch
        )
    }
    deleteRegion = (itemId) => {
        this.props.actions.deleteRegionData(
            itemId,
            this.props.dispatch
        ).then(res => {
                    console.log('f', res)
                   
               this.props.actions.getAllRegionSettings();
        
                });;
    }
    render(){
        return(
            <div>
                <RegionComponent
                    RegionDetails = {this.props.RegionData}
                    addRegion = {this.addRegionSetting}
                    deleteRegionItem = {this.deleteRegion}
                    getRegion ={this.getRegion}
                    updateRegion = {this.updateRegion}
                    getRegionList={this.getRegionData}
                >
                </RegionComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllRegionSettings,
            addRegionData,
            deleteRegionData,
            editRegionData
        },
            dispatch)
    };
}
function mapStateToProps({ RegionReducer }) {
    console.log(RegionReducer);
    return {
        RegionData : {
            errorCode : RegionReducer.errorCode,
            statusCode : RegionReducer.statusCode,
            regionList : RegionReducer.regionList,
            message : RegionReducer.message,
            UpdatedList : RegionReducer.UpdatedList
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegionContainer));